export const formatNumberShort = (input) => {
  const num = Number(input); // Convert string like "8400.000" to a number

  const format = (n, suffix, divisor) => {
    const val = n / divisor;
    return (val % 1 === 0 ? val : val.toFixed(1)) + suffix;
  };

  if (num >= 1_000_000_000) {
    return format(num, "B", 1_000_000_000);
  } else if (num >= 1_00_00_000) {
    return format(num, "Cr", 1_00_00_000);
  } else if (num >= 1_000_000) {
    return format(num, "M", 1_000_000);
  } else if (num >= 1_00_000) {
    return format(num, "L", 1_00_000);
  } else if (num >= 10_000) {
    return format(num, "K", 1_000);
  }

  // Handle small numbers without unnecessary ".0"
  return num % 1 === 0 ? num.toString() : num.toFixed(1);
};
